export const INPUT_TYPES = Object.freeze({
    TEXT: 'TEXT',
    NUMBER: 'NUMBER',
    SELECT: 'SELECT',
    BUTTON: 'BUTTON',
    DATE_PICKER: 'DATE_PICKER',
    MULTIPLE_CHOICES: 'MULTIPLE_CHOICES',
    SEARCH_MULTIPLE_CHOICES: 'SEARCH_MULTIPLE_CHOICES',
})